import React from 'react'
import {
  IconUsers,
  IconTag,
  IconBook,
  IconTrophy,
  IconArrowsSort,
  IconPaperclip,
  IconMoodSmile,
  IconPhoneOutgoing,
  IconListCheck,
  IconRobot,
  IconCalendar,
  IconGlobe,
  IconClock,
  IconUser,
  IconMessageDots,
  IconSearch,
  IconClipboardCheck,
  IconTargetArrow,
  IconClipboardData,
  IconChecklist,
} from '@tabler/icons-react'

import {
  agentTypeOptions,
  directionOptions,
  attachmentOptions,
  sentimentOptions,
  scoredOptions,
} from '@/utils/constants'
import { getScorecardOptions } from '@/utils/helpers'

const isWinOptions = [
  { value: 'true', label: 'Only Wins' },
  { value: 'false', label: 'Only Non-wins' },
]

const scorecardThresholdOptions = [
  { value: 'improvement_threshold', label: 'Needs Improvement' },
  { value: 'meets_threshold', label: 'Meets Expectations' },
  { value: 'exceeds_threshold', label: 'Exceeds Expectations' },
]

export const getInteractiveFilterConfig = (data, loading) => ({
  agents: {
    component: 'multiSelect',
    icon: <IconUsers />,
    options: data.agents,
    loading: loading.agents,
    isSelectAll: true,
  },
  tags: {
    component: 'multiSelect',
    icon: <IconTag />,
    options: data.tags,
    loading: loading.tags,
    isSelectAll: true,
  },
  agentType: {
    component: 'dropdown',
    icon: <IconRobot />,
    options: agentTypeOptions,
  },
  isWin: {
    component: 'dropdown',
    icon: <IconTrophy />,
    options: isWinOptions,
  },
  direction: {
    component: 'dropdown',
    icon: <IconArrowsSort />,
    options: directionOptions,
  },
  attachments: {
    component: 'multiSelect',
    icon: <IconPaperclip />,
    options: attachmentOptions,
  },
  endingSentiment: {
    component: 'multiSelect',
    icon: <IconMoodSmile />,
    options: sentimentOptions,
  },
  voipCampaigns: {
    component: 'multiSelect',
    icon: <IconPhoneOutgoing />,
    options: data.voipCampaigns,
    loading: loading.voipCampaigns,
    isSelectAll: true,
  },
  playbooks: {
    component: 'multiSelect',
    icon: <IconBook />,
    options: data.playbooks,
    loading: loading.playbooks,
    isSelectAll: true,
  },
  scorecards: {
    component: 'multiSelect',
    icon: <IconListCheck />,
    options: getScorecardOptions(data.scorecardConfigs),
    loading: loading.scorecards,
    isSelectAll: true,
  },
  scoredStatus: {
    component: 'dropdown',
    icon: <IconClipboardCheck />,
    options: scoredOptions,
  },
  scorecardThreshold: {
    component: 'dropdown',
    icon: <IconTargetArrow />,
    options: scorecardThresholdOptions,
  },
  duration: {
    icon: <IconClock />,
  },
  voipCustomerIds: {
    icon: <IconUser />,
  },
  notifications: {
    icon: <IconMessageDots />,
  },
  keywords: {
    icon: <IconSearch />,
  },
  postcall: {
    icon: <IconClipboardData />,
  },
  checklist: {
    icon: <IconChecklist />,
  },
})

export const dateIcon = <IconCalendar />
export const organizationIcon = <IconGlobe />

/**
 * Names for `CallSearchFilters`' `hiddenFilters` prop.
 *
 * A host page that cannot apply a filter passes its name here so the section is
 * not rendered at all. Hiding beats disabling: a filter the page will not apply
 * returns numbers that look like it was honoured.
 */
export const KEYWORD_FILTERS = 'keywords'
export const AI_AGENT_FILTERS = 'aiAgent'
export const CHANNEL_FILTER = 'channel'
export const NOTETAKER_FILTERS = 'notetaker'
